import { startRelay } from '../actions';
import { PostMessagePortal } from './PostMessagePortal';
import { PortalConfig } from '../types';

interface TargetPortalConfig {
  portalConfig: PortalConfig;
  externalWindow: Window;
  currentWindow?: Window;
  debug: boolean;
  logTag: string;
}

/**
 * TargetPortal
 * Consider using TargetPortalHub instead, it handles listening for
 * "BRIDGE_REQUEST"s and instantiate TargetPortals.
 *
 * If you need something lower level, this is the portal class you would
 * instantiate in response to a "BRIDGE_REQUEST" from a valid document.
 *
 */
export class TargetPortal extends PostMessagePortal {
  constructor({
    portalConfig,
    externalWindow,
    currentWindow = window,
    logTag,
    debug,
  }: TargetPortalConfig) {
    super({ portalConfig, externalWindow, currentWindow, logTag, debug });

    this.postMessageOverBridge(startRelay({ portalConfigId: portalConfig.id }));
  }
}
